import parse from 'html-react-parser';

const HTMLText = ({ text }: { text: string }) => <>{parse(text)}</>;

export default HTMLText;
